import { createContext, useContext, useState } from "react";

const NavContext = createContext();

export const NavProvider = ({ children }) => {
  const [links, setLinks] = useState([]);

  const addLink = (name, path) => {
    setLinks((prev) => {
      if (!prev.some((link) => link.path === path)) {
        return [...prev, { name, path }];
      }
      return prev;
    });
  };

  return (
    <NavContext.Provider value={{ links, addLink }}>
      {children}
    </NavContext.Provider>
  );
};

export const useNav = () => useContext(NavContext);
